import { Text } from '@cinch-labs/design-system'

import styles from './header.module.css'

export interface HeaderProps {
  title: string
  subtitle: string
}

export const ReviewsPageHeader: React.FC<HeaderProps> = ({
  title,
  subtitle,
}) => (
  <section className={styles.reviewsHeader} data-testid="reviews-hub-title">
    <Text fontWeight="bold" fontSize="4xl" element="h1">
      {title}
    </Text>

    <Text className={styles.subtitle} fontWeight="light" fontSize="xxl">
      {subtitle}
    </Text>
  </section>
)
